export default __webpack_public_path__ + "static/media/Experience Selector.edc8eb82.svg";